import {DxModalResultType} from "./dx-modal-result-type";


/**
 * Реузльтат, получаемый на момент закрытия модального окна пользователем.
 * По-идее, можно было бы обойтись и типом, но ионгда нужно возвращать данные.
 * Например отредактированный объект.
 */
export class DxModalResult {
  /** Тип действия с которым было закрыто модальное окно. */
  private readonly _type: DxModalResultType;
  /** Объект данных произвольного типа. */
  private readonly _data: any;

  constructor(type: DxModalResultType, data?: any) {
    this._type = type;
    this._data = data;
  }

  get type(): DxModalResultType {
    return this._type;
  }

  get data(): any {
    return this._data;
  }
}
